import { Container } from "unstated"
import { root } from "../services/Globals"
import { Subject, from } from "rxjs"
import { debounceTime, mergeMap, map, switchMap } from "rxjs/operators"

const initialState = {
  choirId: undefined,
  isFetching: false,
  data: [],
  filters: {
    search: undefined,
    limit: 50,
    sort: undefined,
    onlyAssignable: false,
  },
  next: undefined,
}

class LicensesContainer extends Container {
  constructor() {
    super()
    this.state = { ...initialState }

    this.fetch$ = new Subject()
    this.fetch$
      .pipe(
        debounceTime(200),
        mergeMap(
          choirId =>
            new Promise(resolve => {
              this.setState(
                previousState => ({
                  ...previousState,
                  ...(choirId ? { choirId } : {}),
                  isFetching: true,
                }),
                () => resolve(this.state)
              )
            })
        ),
        map(state =>
          state.next
            ? {
                url: state.next,
              }
            : {
                url: `/choirs/${ state.choirId }/licences`,
                params: {
                  ...Object.keys(state.filters).reduce(
                    (params, filterName) =>
                      state.filters[filterName]
                        ? {
                            ...params,
                            [filterName]: state.filters[filterName],
                          }
                        : params,
                    {}
                  ),
                },
              }
        ),
        switchMap(configuration => from(root.wav.api(configuration))),
        map(({ data }) => data)
      )
      .subscribe(
        data => {
          this.setState(previousState => ({
            ...previousState,
            isFetching: false,
            data: this.state.next
              ? [ ...this.state.data, ...data.items ]
              : data.items,
            next: data.next ? data.next : undefined,
          }))
        },
        error => {
          console.error(error)
          this.setState(previousState => ({
            ...previousState,
            isFetching: false,
          }))
        }
      )
  }

  fetch = (choirId = this.state.choirId) => this.fetch$.next(choirId)

  filter = filters => {
    const { choirId } = this.state
    this.setState({
      ...initialState,
      choirId,
      filters: {
        ...this.state.filters,
        ...filters,
      },
    })

    this.fetch$.next()
  }

  // removeId = id => {
  //   this.setState(previousState => ({
  //     ...previousState,
  //     data: [ ...this.state.data.filter(item => item.id !== id) ]
  //   }))
  // }

  updateLicenses = license => {
    this.setState(previousState => ({
      ...previousState,
      data:
        this.state.data.filter(item => item.id === license.id).length === 1
          ? this.state.data.map(item =>
              item.id === license.id ? license : item
            )
          : [ ...this.state.data, license ],
    }))
  }

  resetState = () => {
    this.setState({ ...initialState })
  }
}

export { LicensesContainer }
